import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Bar from '@/components/Bar.vue'
import Foot from '@/components/Foot.vue'
import Main from '@/views/page/Main.vue'
import Product from '@/views/page/Product.vue'
import Samples from '@/views/page/Samples.vue'
import AboutUs from '@/views/page/AboutUs.vue'
import AboutUsSwiper from '@/components/AboutUsSwiper.vue'
import Earth from '@/components/Earth.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
	redirect:'main',
	children: [
		{
			path:'main',
			component:Main,
			meta: {
				title: '时空视界|时空大数据可视化解决方案'
			}
		},
		{
			path:'product',
			component:Product,
			meta: {
				title: '时空视界|行业产品'
			}
		},
		{
			path:'samples',
			component:Samples,
			meta: {
				title: '时空视界|案例'
			}
		},
		{
			path:'aboutUs',
			component:AboutUs,
			meta: {
				title: '时空视界|关于我们'
			}
		}
	]
  },
  {
	path: '/bar',
	name: 'Bar',
	component: Bar
  },
  {
  	path: '/foot',
  	name: 'Foot',
  	component: Foot
  },
  {
 	path:'/aboutUsSwiper',
 	component:AboutUsSwiper
  },
  {
	path:'/earth',
	component:Earth
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
